import React, { FC, useEffect, useState } from "react";
import get from "lodash/get";
import clsx from "clsx";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";

import { useForm } from "react-hook-form/dist/index.ie11";

import {
  ContractType,
  useAddNotificationMutation,
  useGetFileLinksLazyQuery,
  useGetTemplatesQuery,
  useSetAddValuesNotesMutation,
  useSetAddValuesPersonalMutation,
  useSetDealerFixPlanAddDocumentMutation,
  useSetDealerFixPlanRemoveDocumentDocumentMutation,
  useSetDealerStateFixDoneMutation,
} from "~/schemas/generated/graphql";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import Button from "~/shared/ui/Fields/Button";

import s from "./UsersForm.less";

import Clip from "~/components/Icons/clip";
import MultiFileLoader from "~/components/MultiFileLoader";
import Enter from "~/components/Icons/arrow-enter";
import ProofDocumentControl from "~/components/Forms/ViolationRecordingForm/ProofDocumentControl";
import { yupResolver } from "@hookform/resolvers/yup";
import DropZone from "~/components/DropZone";
import Table from "~/components/Table";
import { FILE_OPTIONS } from "~/pages/PKD/PKDFiles/options";
import Pagination from "~/components/Pagination";
import IconUpdate from "~/components/Icons/icon-update";
import IconDownload from "~/components/Icons/icon-download";
import IconTrash from "~/components/Icons/icon-trash";

import { NOTIFICATIONS } from "~/constans/notifications";
import Preloader from "~/components/Preloader";
import Modal from "~/shared/ui/Fields/Modal";
import UploadHTMLForm from "~/components/Forms/UploadHTMLForm";
import { ROLE_TYPES } from "~/constans/roles";
import Filter from "~/components/Filter";

interface IProps {
  setCloseModal: () => void;
  Files?: any[];
  isResolved?: boolean;
  selectedService?;
}

const DealersHtmlFilesForm: FC<IProps> = ({
  setCloseModal,
  selectedService,
  Files,
  isResolved = false,
}) => {
  const { t } = useTranslation();
  const currentDealerId = useCurrentDealerId();
  const optionsType = ["Custom", "Contract"];
  const setData = useSetLocationData();

  const {
    UserId,
    dateBegin,
    fullname,
    dateEnd,
    countModal,
    pageModal,
    openChildModal,
    currentId,
    searchField,
  } = useGetLocationData();

  const { data, loading, refetch } = useGetTemplatesQuery({
    variables: {
      page: pageModal,
      count: countModal,
      type: searchField ? ContractType[searchField] : ContractType["Contract"],
    },
  });

  const getTemplate = get(data, "DealerRegistryGetter.getTemplates.items", []);
  const total = get(data, "DealerRegistryGetter.getTemplates.total", 0);

  const [addNotificationMutation] = useAddNotificationMutation({});

  const [dealerFixPlanRemoveDocument] =
    useSetDealerFixPlanRemoveDocumentDocumentMutation({
      onCompleted() {
        refetch();
      },
    });

  const deleteFilesOnSubmit = (arr) => {
    if (arr.length) {
      const resultArr = [...arr];
      const id = resultArr.pop();
      dealerFixPlanRemoveDocument({
        variables: {
          PlanReportId: currentId,
          DealerId: currentDealerId,
          fileId: id,
        },
      });
      deleteFilesOnSubmit(resultArr);
    } else {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.success,
          content: t("common.files_deleted_successfully"),
        },
      });
    }
  };

  const htmlUrl = (data) => {
    let blob = new Blob([data], { type: "text/html" });
    URL.createObjectURL(blob);

    return (
      <a href={URL.createObjectURL(blob)} download className={s.customBtn}>
        <IconDownload fill={"#878E94"} />
      </a>
    );
  };
  const OpenModalUpload = () => {
    setData("openChildModal", "html");
  };

  const handleCloseChildModal = () => {
    setData("openChildModal", "");
  };

  if (loading) {
    return <Preloader />;
  }

  return (
    <div className={s.ind_form}>
      <div className={s.wrapperForm}>
        <Filter
          width={150}
          type={"dealers"}
          options={optionsType}
          isNoneFilterBy={false}
        />

        <Button
          txtBtn={t("dealers.html")}
          onClick={OpenModalUpload}
          orange
          small
          withMargin
          // customClassName={s.btn_sync}
        />
      </div>
      <ul className={s.list}>
        <form className={s.form_comment}>
          <Pagination modal showline total={total}>
            <div className={s.form_wrapper}>
              {getTemplate.length > 0 && (
                <div className={s.wrapper_files}>
                  {/*<div className={s.title_files}>*/}
                  {/*  {t("planReport.planReportScan")}*/}
                  {/*</div>*/}
                  <div className={s.items_comments}>
                    {getTemplate.map(({ name, html, type }) => (
                      <div
                        className={clsx(
                          // filesOnDelete.includes(id) && s.onDelete,
                          s.wrapper,
                          s.wrapperPlan
                        )}
                      >
                        <div className={clsx(s.filePreview, s.filePreviewPlan)}>
                          {name}
                        </div>
                        {/*<div className={s.typeStyle}>   {t(`dealers.${type}`) }</div>*/}
                        {htmlUrl(html)}
                        <div
                          className={clsx(s.fileControls, s.fileControlsPlan)}
                        ></div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Pagination>
          <div className={s.line} />
        </form>
      </ul>

      <Modal
        isOpen={openChildModal === "html"}
        title={t("pkd.upload_file")}
        actionClose={handleCloseChildModal}
      >
        <UploadHTMLForm
          refetch={refetch}
          setCloseModal={handleCloseChildModal}
        />
      </Modal>
    </div>
  );
};
export default DealersHtmlFilesForm;
